// Utility to validate menu config structure
// Usage: import { validateMenuConfig } from './utils/menuConfigValidator';
//        const errors = validateMenuConfig(APP_MENU_CONFIG);
//        if (errors.length > 0) errors.forEach(e => console.error(e));

export function validateMenuConfig(menuConfig) {
  const errors = [];
  const paths = new Set();

  Object.entries(menuConfig).forEach(([key, config]) => {
    if (!config.text) errors.push(`Menu item '${key}' is missing 'text'.`);
    if (!config.icon) errors.push(`Menu item '${key}' is missing 'icon'.`);
    if (!config.path) errors.push(`Menu item '${key}' is missing 'path'.`);
    if (paths.has(config.path)) errors.push(`Duplicate path '${config.path}' found in menu item '${key}'.`);
    paths.add(config.path);
  });

  return errors;
}
